export default "__VITE_ASSET__DvGWlD5___"